import React from 'react';
import { func, number, string } from 'prop-types';
import { omit } from 'lodash';
import { Tooltip, Icon } from '@fiverr-private/fit';
import { QuestionSolidIcon } from '@fiverr-private/icons';
import { grey_900 } from '@fiverr-private/sass/helpers';

const DEFAULT_SIZE = 16;

/**
 * @deprecated Please use Tooltip from @fiverr-private/tooltip instead.
 */
const TooltipIcon = ({
    color,
    size,
    icon,
    iconAriaLabel,
    ...rest
}) => (
    <Tooltip {...rest}>
        <Icon size={size} color={color} ariaLabel={iconAriaLabel}>{icon}</Icon>
    </Tooltip>
);

TooltipIcon.displayName = 'TooltipIcon';

TooltipIcon.propTypes = {
    /**
     * The icon's color. Accepts any CSS-supported color.
     */
    color: string,
    /**
     * The icon's size, in pixels.
     */
    size: number,
    /**
     * The icon that trigger the Tooltip.
     */
    icon: func,
    /**
     * Accessibility text for screen readers.
     */
    iconAriaLabel: string
};

TooltipIcon.defaultProps = {
    size: DEFAULT_SIZE,
    color: grey_900,
    icon: QuestionSolidIcon
};

Object.assign(TooltipIcon.propTypes, omit(Tooltip.propTypes, 'children')); // Support Storybook's prop table.
Object.assign(TooltipIcon, {
    POSITIONS: Tooltip.POSITIONS
});

export default TooltipIcon;
